module.exports = __webpack_public_path__ + "static/DS_anniversary-abc0044e67b32ee070be3db9d32a2835.jpeg";